import { JsonSchemaValidator } from "@common/json-schema-validator";
import { NoticeEntityId } from "../interface";
import { noticeEntityId } from "../schema";

export class NoticeDeleteCmd {
  private static configValidation = JsonSchemaValidator.compile(
    NoticeDeleteCmd.configValidationSchema()
  );

  readonly value: Notice;

  constructor(value: Notice) {
    this.value = JsonSchemaValidator.assert(
      NoticeDeleteCmd.configValidation,
      value
    );
  }

  private static configValidationSchema() {
    return {
      type: "object",
      required: ["id"],
      properties: {
        id: noticeEntityId
      },
      additionalProperties: false
    };
  }
}

interface Notice {
  id: NoticeEntityId;
}
